import { Button, Stack, styled } from '@mui/material';
import { type ErrorComponentProps, useRouter } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { ForbiddenError } from '@@router/guards';

import { Error403 } from './Error403';

const WrapperStack = styled(Stack)(({ theme }) => ({
    width: '100%',
    height: '100%',
    maxWidth: theme.fixed.errorPage.maxWidth,
    margin: '0 auto',
    padding: theme.spacing(5),
    alignItems: 'center',
    justifyContent: 'center',
}));

const Title = styled('h1')(({ theme }) => ({
    ...theme.typography.title1,
    marginBottom: theme.spacing(5),
    marginTop: 0,
}));

const Subtitle = styled('h2')(({ theme }) => ({
    ...theme.typography.large,
    textAlign: 'center',
    margin: `0 0 ${theme.spacing(3)} 0`,
}));

export const ErrorPage = ({ error }: ErrorComponentProps) => {
    const { t } = useTranslation();
    const router = useRouter();

    if (error instanceof ForbiddenError) {
        return <Error403 />;
    }

    return (
        <WrapperStack>
            <Title>{t('errorPage.title')}</Title>
            <Subtitle>{t('errorPage.subtitle')}</Subtitle>
            {/* Loads the page again, which also clears the error */}
            <Button color="secondary" variant="contained" onClick={() => router.invalidate()}>
                {t('errorPage.button')}
            </Button>
        </WrapperStack>
    );
};
